var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{staticClass:"btn-responsive btn-send-email",attrs:{"color":"primary","elevation":"2","disabled":_vm.isButtonDisabled},on:{"click":_vm.sendWaiver}},[_vm._v(" "+_vm._s(_vm.textBtn)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }